





















import Vue from "vue";
import TypeOfProperty from "@/encoding/pages/TypeOfProperty.vue";
import iwNextPreviousButton from "@/encoding/components/NextPreviousButton.vue";
import { pushPageViewEvent } from "@/shared/store/modules/gtm/datalayer";
import { updateClassified, validationClassified } from "@/shared/scripts/ValidateData";
import { mapActions } from "vuex";
import { i18n } from "@/shared/scripts/helpers/translation/i18n";

export default Vue.extend({
    components: {
        TypeOfProperty: TypeOfProperty,
        iwNextPreviousButton: iwNextPreviousButton
    },

    data: function() {
        return {
            isButtonDisabled: false as boolean
        };
    },

    mounted: function() {
        pushPageViewEvent("classified_deposit_step1_propertyType");
    },


    methods: {
        ...mapActions({
            validateAndGoToNextStep: "FormModule/validateAndGoToNextStep",
            goToPreviousStep: "FormModule/goToPreviousStep",
            goToNextStep: "StepsWizard/next"
        }),
        getUrl: function(key: string) {
            return process.env.VUE_APP_IMMOWEB_URL + i18n.t(key).toString();
        },
        clickNext: function(){
            this.isButtonDisabled = true;
            if (this.$store.getters["FormModule/getIsEditionMode"]){
                validationClassified((success:boolean) => {

                    Vue.nextTick(() => {
                        const inputsError = document.getElementsByClassName("input--error") as HTMLCollectionOf<HTMLElement>;

                        if (inputsError.length > 0) {
                            inputsError[0].focus();
                            window.scrollTo(0, 0);
                        }

                        this.isButtonDisabled = false;
                        if (success && this.getPropertyType()) {
                            this.goToNextStep();
                        }
                    });
                });
            } else {
                updateClassified((success:boolean) => {
                    this.isButtonDisabled = true;

                    Vue.nextTick(() => {
                        const inputsError = document.getElementsByClassName("input--error") as HTMLCollectionOf<HTMLElement>;

                        if (inputsError.length > 0) {
                            inputsError[0].focus();
                            window.scrollTo(0, 0);
                        }

                        this.isButtonDisabled = false;
                        if (success && this.getPropertyType()) {
                            this.goToNextStep();
                        }
                    });
                });
            }
        },
        clickPrevious: function(){
            //this.goToPreviousStep();
            //this.routeToPage("step-property-type");
        }
    }
});

